import React, {useState} from 'react';
import { Form, Checkbox, Input, Radio, Space, InputNumber  } from 'antd';

interface FormItemProps {
  form: any
}

const EvaluationFormItem = ({form}: FormItemProps): React.ReactElement => {
  /* ======================================================
   * variables
   * ====================================================== */
  const [maxValue, setMaxValue] = useState<number>(5);
  /* ======================================================
  * hooks
  * ====================================================== */

  /* ======================================================
  * events
  * ====================================================== */  

  /* ======================================================
  * effects
  * ====================================================== */  

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <>
      <div>
        <Form.Item style={{ display: 'inline-block'}}>
          <label>NPS :&nbsp;</label>
        </Form.Item>     
        <Form.Item name="nps_evaluation" style={{ width:'100px', display: 'inline-block'}}>
          <InputNumber max={100} />
        </Form.Item> 
        <Form.Item style={{ display: 'inline-block', marginLeft:'10px'}}>
          <label>평점 :&nbsp;</label>
        </Form.Item>     
        <Form.Item name="class_evaluation" style={{ width:'100px', display: 'inline-block'}}>
          <InputNumber/>
        </Form.Item>         
      </div>
      <div>
        <Form.Item name='class_evaluation_max' style={{ display: 'inline-block', marginTop:'5px'}}>
        <Radio.Group onChange={(e)=>setMaxValue(e.target.value)}>
          <Space direction="vertical">
            <Radio value={5}>Max 5점</Radio>
            <Radio value={7}>Max 7점</Radio>
            <Radio value={10}>Max 10점</Radio>
          </Space>
        </Radio.Group>
        </Form.Item>     
      </div>       
      <div>
        <Form.Item name='is_no_evaluation' valuePropName="checked" style={{ display: 'inline-block', marginTop:'5px'}}>
          <Checkbox>강의평가 결과 없음</Checkbox>  
        </Form.Item>     
      </div>      
    </>
  );
};

export default EvaluationFormItem;
